import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/src/components/ui/toaster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TooltipProvider"] */ "/app/src/components/ui/tooltip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BackendClientProvider"] */ "/app/src/providers/api_client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["JotaiProviders"] */ "/app/src/providers/jotai_provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PHProvider"] */ "/app/src/providers/posthog_provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProviderWrapper"] */ "/app/src/providers/theme_provider.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/styles/globals.css");
